import Currency from "./CurrencyCodeEnum";
import Amount from "@/module/main/dto/Amount";
import IAmountVat from "@/module/main/dto/IAmountVat";

export default class AmountVat extends Amount implements IAmountVat {
    constructor(public value: number = 0,
                public currency: Currency = Currency.CZK,
                public vatRate: number = 0) {
        super(value, currency);
    }
}
